import { Pipe, PipeTransform } from '@angular/core';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';

@Pipe({ name: 'includeContactFilterTypes', standalone: false })
export class IncludeContactFilterTypesPipe implements PipeTransform {
    transform(filterType: SystemEntity): boolean {
        return [
            SystemEntity.Lead,
            SystemEntity.Person,
            SystemEntity.Adviser,
            SystemEntity.Client,
            SystemEntity.Organisation,
            SystemEntity.Intermediary,
        ].includes(filterType);
    }
}
